export function parseDate(dateString) {
  return dateString !== null ? Date.parse(dateString) : null;
}

export function parseDateToDate(dateString) {
  return dateString !== null ? new Date(Date.parse(dateString)) : null;
}
